import {
	RESET_SEARCH_PARAMS,
	SET_LOADING_LOGS,
	SET_SEARCH_PARAMS,
	SET_WATCHLIST_SEARCH_PARAMS
} from "@/store/mutations.type";
import {GET_FILTER_DATA, SEARCH_LOGS} from "@/store/actions.type";
import {mapGetters} from "vuex";

/**
 * Mixin log search methods
 */
export default {
	data() {
		return {
			// todo this setting is never touched, so the form fields in Searchbar never output an error state
			insufficientSearchParams: false
		}
	},
	computed: {
		...mapGetters(['logSearchParams', 'logSearchResults', 'logSearchResultsExhausted', 'loadingLogs', 'editSearchParams', 'user']),
		/**
		 * Check if search params are valid for a new log search
		 * @returns boolean
		 */
		sufficientSearchParamsGiven() {
			return this.logSearchParams &&
				(this.logSearchParams.species || this.logSearchParams.logNo || this.logSearchParams.palletNo);
		},
	},
	methods: {
		/**
		 * Perform log search with a new species
		 * reset filters depending on previous species
		 * @param species the new species
		 */
		newSpeciesLogSearch(species, triggerSearch = true) {
			if (species !== this.logSearchParams.species && this.user) {
				this.$store.commit(RESET_SEARCH_PARAMS);
				this.$store.commit(SET_SEARCH_PARAMS, {species});
				this.$store.dispatch(GET_FILTER_DATA);
			}

			// do not switch to new search while editing dynamic watchlist search params
			if (!this.editSearchParams) {
				this.goToLogSearch(triggerSearch);
			} else {
				this.loadWatchlistPreview();
			}
		},
		/**
		 * Initial log search
		 * @param {int} offset for query
		 */
		async loadResults(offset = 1) {
			if (this.sufficientSearchParamsGiven) {
				await this.$store.dispatch(SEARCH_LOGS, offset);
			}
		},
		/**
		 * Perform log search or route to logSearch component
		 */
		goToLogSearch(triggerSearch = true) {
			if (this.$route.name !== 'search') {
				this.$router.push({name: 'search'});
			}
			if(triggerSearch) {
				this.loadResults();
			}
		},
		/**
		 * Load additional results by incrementing query offset
		 * @param {int} index how many times this methods has been called by the same component, set by q-infinite-scroll
		 * @param {function} done signal query progress to q-infinite-scroll
		 */
		async loadAdditionalResults(index = 0, done = null) {
			if (!this.loadingLogs && !this.logSearchResultsExhausted) {
				await this.loadResults(parseInt(this.logSearchParams.offset) + parseInt(this.logSearchParams.limit));
			}

			if (done) {
				// wait for dom render
				this.$nextTick(() => {
					done();
				});
			}
		},
		async loadWatchlistPreview() {
			this.$store.commit(SET_WATCHLIST_SEARCH_PARAMS, this.logSearchParams);
			this.loadResults(1);
		},
	}
}